export const SCORE_LIST = 'score_list';
export const SCORE_LIST_SUCCESS = 'score_list_success';
export const GET_ALL_SCORE_LIST = 'get_all_score_list';
export const GET_ALL_SCORE_LIST_SUCCESS = 'get_all_score_list_success';
